export default "__VITE_ASSET__BVPuoLwR__"